import React from 'react'
import { motion, useScroll } from "framer-motion";

const ScrollProgress = () => {
    const { scrollYProgress } = useScroll();
  return (
    <motion.div style={{ scaleX: scrollYProgress }} className='h-0.5 w-full  bg-turkuaz-blue fixed top-0 left-0 z-[500]'></motion.div>
  )
}

export default ScrollProgress